import React, { useState,useEffect } from "react";
import CoachLayout from "../common/CoachLayout";
import { useCoachAuthContext } from "../login/useCoachAuthContext";
import setting from "../../images/setting.svg";
import velocity from "../../images/velocity.svg";
import rocket from "../../images/rocket.svg";
import training from "../../images/training.svg";
import education from "../../images/education.svg";
import { Link } from "react-router-dom";
import API_URL from "../../api/API";


export const CoachTools = () => {

    const {coach}  = useCoachAuthContext();
    const [testResult, setTestResult] = useState(null);
    const [testLVResult,setTestLVResult] = useState(null);

    const fetchTestResults = async () => {
      try {
          const response = await fetch(API_URL.GET_COACH_RUNROCKET_TEST_RESULT + coach.id, {
              method: "GET",
              headers: {
                  "Authorization": `Bearer ${coach.token}`,
              },
          });
          
          if (!response.ok) {
              throw new Error("Failed to fetch test results");
          }
          
          const data = await response.json();
          setTestResult(data);
          console.log(data);
      } catch (error) {
          console.log(error.message);
      }
  };

  const fetchLVTestResults = async () => {
    try {
        const response = await fetch(API_URL.GET_COACH_LOADVELOCITY_TEST_RESULT + coach.id, {
            method: "GET",
            headers: {
                "Authorization": `Bearer ${coach.token}`,
            },
        });
        
        if (!response.ok) {
            throw new Error("Failed to fetch test results");
        }
        
        const data = await response.json();
        setTestLVResult(data);
        console.log(data);
    } catch (error) {
        console.log(error.message);
    }
};

     // Fetch athlete's RunRocket test results on component mount
     useEffect(() => {
      fetchTestResults();
      fetchLVTestResults();
  }, [coach.token]);

    return (
      <CoachLayout>
      
        <div className="min-h-min h-full bg-[#F6F6F6]">
        <div className="w-full max-w-2xl mx-auto px-5">
          
          {
            coach.account_type!="AMAX COACHED" && (
              <>
                 <Link to="/coach/purchase/static-speed-templates">
                  <button className={`py-5 w-full flex flex-row gap-4 border-b border-black/20 text-black text-sm font-normal transition group hover:font-bold`} >
                  <div className="w-6">
                          <img src={setting} alt="setting" className="object-contain" />
                  </div>
                  Static Speed Templates
                  </button>
                </Link>


                <Link to="/coach/purchase/static-strength-templates">
                    <button className={`py-5 w-full flex flex-row gap-4 border-b border-black/20 text-black text-sm font-normal transition group hover:font-bold`} >
                    <div className="w-6">
                            <img src={setting} alt="setting" className="object-contain" />
                    </div>
                    Static Strength Templates
                    </button>
                </Link>


                {testResult?.data.rsquared && testResult.data.rsquared >=95 ? (
                      <Link to="/coach/tools/runrocket/test/result">
                      <button
                        className={`py-5 w-full flex flex-row gap-4 border-b border-black/20 text-black text-sm font-normal transition group hover:font-bold`}
                      >
                        <div className="w-6">
                        <img src={rocket} alt="rocket" className="object-contain" />
                        </div>
                        Run Rocket Training
                      </button>
                    </Link>      
                ):(
                  <Link to="/coach/purchase-runrocket-tool">
                      <button
                        className={`py-5 w-full flex flex-row gap-4 border-b border-black/20 text-black text-sm font-normal transition group hover:font-bold`}
                      >
                        <div className="w-6">
                        <img src={rocket} alt="rocket" className="object-contain" />
                        </div>
                        Run Rocket Training
                      </button>
                  </Link>      
                )}


                {testLVResult?.data.rsquared && testLVResult.data.rsquared > 98 ? (
                      <Link to="/coach/tools/loadvelocity/test/result">
                      <button
                        className={`py-5 w-full flex flex-row gap-4 border-b border-black/20 text-black text-sm font-normal transition group hover:font-bold`}
                      >
                        <div className="w-6">
                        <img src={rocket} alt="rocket" className="object-contain" />
                        </div>
                        Load Velocity Training
                      </button>
                    </Link>      
                ):(
                  <Link to="/coach/purchase-loadvelocity-tool">
                      <button
                        className={`py-5 w-full flex flex-row gap-4 border-b border-black/20 text-black text-sm font-normal transition group hover:font-bold`}
                      >
                        <div className="w-6">
                        <img src={velocity} alt="loadvelocity" className="object-contain" />
                        </div>
                       Load Velocity Profiling
                      </button>
                  </Link>     
                )}
              </>
            )
          }

            </div>  
        </div>
      
      </CoachLayout>
    )
}
